import React, { useCallback, useEffect, useState } from 'react';
import MailIcon from '@assets/svgs/mail-icon.svg';
import XIcon from '@assets/svgs/x-icon.svg';
import UiButton from '@components/ui/button/UiButton';
import FormBuilder from '@components/client-components/form-builder/FormBuilder';
import { Spin } from 'antd';
import { useTranslation } from 'next-i18next';
import { getGeneralForm } from '@services/form/form-http.service';
import { FormModel } from '@models/form';
import useNotification from '@hooks/notification/useNotification';
import StateEnum from '@constants/state.enum';
import styles from './SendCv.module.scss';

type SendCvProps = {
  slug: string;
  clientColor: string;
  showForm: boolean;
  setShowForm: (value: boolean) => void;
};

const SendCv: React.FC<SendCvProps> = ({ slug, clientColor, showForm, setShowForm }) => {
  const { t: translate, i18n } = useTranslation('form');
  const [loading, setLoading] = useState<boolean>(true);
  const [formFields, setFormFields] = useState<FormModel>([]);

  const [generalError] = useNotification(
    StateEnum.ERROR,
    'Something went wrong',
    'Oops, something went wrong, please try again later!',
  );
  const [companyNotFoundError] = useNotification(
    StateEnum.ERROR,
    'Company not found',
    'Oops, the company you are trying does not exist.',
  );

  const fetchForm = useCallback(async () => {
    try {
      const formFieldsElem: FormModel = await getGeneralForm(slug, i18n.language);
      setFormFields(formFieldsElem);
      setLoading(false);
    } catch (e: any) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      e.ErrorMessage === 'company name not found' ? companyNotFoundError() : generalError();
      setLoading(true);
    }
  }, [slug]);

  useEffect(() => {
    setLoading(true);
    fetchForm();
  }, [fetchForm]);

  const closeForm = () => {
    setShowForm(false);
  };

  return (
    <div className={styles.sendCvOuterWrap}>
      <div className={styles.sendCvWrap}>
        <div className={styles.firstStepWrap} style={{ display: showForm ? 'none' : 'flex' }}>
          <MailIcon className={styles.icon} />
          <h3 className={styles.title}>{translate('submit_cv')}</h3>
          <UiButton
            onClick={() => {
              setShowForm(true);
            }}
            type="primary"
            htmlType="submit"
            style={{ backgroundColor: clientColor, borderColor: clientColor }}
          >
            {translate('start_now')}
          </UiButton>
        </div>

        <div className={styles.secondStepWrap} style={{ display: showForm ? 'flex' : 'none' }}>
          <div className={styles.titleIconWrap}>
            <h3 className={styles.title}>{translate('submit_application')}</h3>
            <XIcon onClick={closeForm} className={styles.xIcon} />
          </div>
          {loading ? (
            <Spin size="large" />
          ) : (
            <FormBuilder formFields={formFields} slug={slug} lang={i18n.language} clientColor={clientColor} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SendCv;
